const compositions = [
  {
    id: 1,
    image: "https://i.ibb.co/WWmrN8TM/photo-2026-02-09-17-26-32.jpg",
    code: "Ком. 1",
    price: "",
  },
  {
    id: 2,
    image: "https://i.ibb.co/PZrvfT3f/photo-2026-02-09-17-26-36.jpg",
    code: "Ком. 2",
    price: "",
  },
  {
    id: 3,
    image: "https://i.ibb.co/VcLbkkw1/photo-2026-02-09-17-26-40.jpg",
    code: "Ком. 3",
    price: "",
  },
  {
    id: 4,
    image: "https://i.ibb.co/qMjxpfnY/photo-2026-02-09-17-26-43.jpg",
    code: "Ком. 4",
    price: "",
  },
  {
    id: 5,
    image: "https://i.ibb.co/qwMqbfx/photo-2026-02-09-17-26-46.jpg",
    code: "Ком. 5",
    price: "",
  },
  {
    id: 6,
    image: "https://i.ibb.co/prrc84nq/photo-2026-02-09-17-26-49.jpg",
    code: "Ком. 6",
    price: "",
  },
  {
    id: 7,
    image: "https://i.ibb.co/vvYKDTv6/photo-2026-02-09-17-26-52.jpg",
    code: "Ком. 7",
    price: "",
  },
  {
    id: 8,
    image: "https://i.ibb.co/v6tYpKPQ/photo-2026-02-09-17-26-55.jpg",
    code: "Ком. 8",
    price: "",
  },
  {
    id: 9,
    image: "https://i.ibb.co/VcS1MBTn/photo-2026-02-09-17-26-57.jpg",
    code: "Ком. 9",
    price: "",
  },
  {
    id: 10,
    image: "https://i.ibb.co/xK21xLGk/photo-2026-02-09-17-27-00.jpg",
    code: "Ком. 10",
    price: "",
  },
  {
    id: 11,
    image: "https://i.ibb.co/C3RrTKJZ/photo-2026-02-09-20-49-49.jpg",
    code: "Ком. 11",
    price: "",
  },
  {
    id: 12,
    image: "https://i.ibb.co/FbLc25Qt/photo-2026-02-09-18-48-15.jpg",
    code: "Ком. 12",
    price: "",
  },
  {
    id: 13,
    image: "https://i.ibb.co/5WhHCddB/photo-2026-02-09-17-28-16.jpg",
    code: "Ком. 13",
    price: "",
  },
  {
    id: 14,
    image: "https://i.ibb.co/8LGcmmyq/photo-2026-02-09-17-28-19.jpg",
    code: "Ком. 14",
    price: "",
  },
  {
    id: 15,
    image: "https://i.ibb.co/Y7bBPcFq/photo-2026-02-09-17-28-22.jpg",
    code: "Ком. 15",
    price: "",
  },
  {
    id: 16,
    image: "https://i.ibb.co/WWmwWsDx/photo-2026-02-09-17-28-25.jpg",
    code: "Ком. 16",
    price: "",
  },
  {
    id: 17,
    image: "https://i.ibb.co/VWqdRF5z/photo-2026-02-09-17-28-27.jpg",
    code: "Ком. 17",
    price: "",
  },
  {
    id: 18,
    image: "https://i.ibb.co/RTrJprMM/photo-2026-02-09-17-28-45.jpg",
    code: "Ком. 18",
    price: "",
  },
  {
    id: 19,
    image: "https://i.ibb.co/C38HMmyc/photo-2026-02-09-17-28-49.jpg",
    code: "Ком. 19",
    price: "",
  },
  {
    id: 20,
    image: "https://i.ibb.co/GvVcDzQD/photo-2026-02-09-17-28-53.jpg",
    code: "Ком. 20",
    price: "",
  },
  {
    id: 21,
    image: "https://i.ibb.co/1frKhQYX/photo-2026-02-09-17-28-56.jpg",
    code: "Ком. 21",
    price: "",
  },
  {
    id: 22,
    image: "https://i.ibb.co/8n2DTdTL/photo-2026-02-09-17-29-00.jpg",
    code: "Ком. 22",
    price: "",
  },
  {
    id: 23,
    image: "https://i.ibb.co/BVbGdKFH/photo-2026-02-09-17-27-53.jpg",
    code: "Ком. 23",
    price: "",
  },
  {
    id: 24,
    image: "https://i.ibb.co/6R9GqTRr/photo-2026-02-23-14-55-50.jpg",
    code: "Ком. 24",
    price: "",
  },
  {
    id: 25,
    image: "https://i.ibb.co/TDy7xP8k/photo-2026-02-23-14-55-52.jpg",
    code: "Ком. 25",
    price: "",
  },
  {
    id: 26,
    image: "https://i.ibb.co/QvdHPQ2F/photo-2026-02-23-14-55-53.jpg",
    code: "Ком. 26",
    price: "",
  },
  {
    id: 27,
    image: "https://i.ibb.co/jkTz9Z6J/photo-2026-02-23-14-55-55.jpg",
    code: "Ком. 27",
    price: "",
  },
  {
    id: 28,
    image: "https://i.ibb.co/DDKYd4zG/photo-2026-02-23-14-55-56.jpg",
    code: "Ком. 28",
    price: "",
  },
  {
    id: 29,
    image: "https://i.ibb.co/0yCp3jFH/photo-2026-02-23-14-55-57.jpg",
    code: "Ком. 29",
    price: "",
  },
  {
    id: 30,
    image: "https://i.ibb.co/nMCZY0Q0/photo-2026-02-23-14-55-58.jpg",
    code: "Ком. 30",
    price: "",
  },
  {
    id: 31,
    image: "https://i.ibb.co/wZSbcvRF/photo-2026-02-23-14-55-59.jpg",
    code: "Ком. 31",
    price: "",
  },
  {
    id: 32,
    image: "https://i.ibb.co/vvwqXkPr/photo-2026-02-23-14-56-01.jpg",
    code: "Ком. 32",
    price: "",
  },
  {
    id: 33,
    image: "https://i.ibb.co/1Yfz2gyg/photo-2026-02-23-14-56-02.jpg",
    code: "Ком. 33",
    price: "",
  },
  {
    id: 34,
    image: "https://i.ibb.co/KpJf0vv7/photo-2026-02-23-14-56-04.jpg",
    code: "Ком. 34",
    price: "",
  },
  {
    id: 35,
    image: "https://i.ibb.co/5h2N6KnR/photo-2026-02-23-14-56-05.jpg",
    code: "Ком. 35",
    price: "",
  },
  {
    id: 36,
    image: "https://i.ibb.co/RpN6yX32/photo-2026-02-23-14-56-06.jpg",
    code: "Ком. 36",
    price: "",
  },
  {
    id: 37,
    image: "https://i.ibb.co/PzvDKHzY/photo-2026-02-23-14-56-08.jpg",
    code: "Ком. 37",
    price: "",
  },
  {
    id: 38,
    image: "https://i.ibb.co/tpQd6qZ6/photo-2026-02-23-14-56-09.jpg",
    code: "Ком. 38",
    price: "",
  },
  {
    id: 39,
    image: "https://i.ibb.co/LFGGzTG/photo-2026-02-23-14-56-10.jpg",
    code: "Ком. 39",
    price: "",
  },
  {
    id: 40,
    image: "https://i.ibb.co/B2JDdNFX/photo-2026-02-23-14-56-11.jpg",
    code: "Ком. 40",
    price: "",
  },
  {
    id: 41,
    image: "https://i.ibb.co/BVGhQdbR/photo-2026-02-23-14-56-13.jpg",
    code: "Ком. 41",
    price: "",
  },
  {
    id: 42,
    image: "https://i.ibb.co/RpSxJ5Wk/photo-2026-02-23-14-56-14.jpg",
    code: "Ком. 42",
    price: "",
  },
  {
    id: 43,
    image: "https://i.ibb.co/fGxL4Hgy/photo-2026-02-23-14-56-15.jpg",
    code: "Ком. 43",
    price: "",
  },
];

export default compositions;
